export const parkingConditionDetailTokenTranslations = {
  agricultural: 'Land-/Forstwirtschaftlicher Verkehr',
  autumn: 'Herbst',
  axleload: 'Achslast',
  bus: 'Busse',
  car_sharing: 'Carsharing',
  customers: 'Kund:innen',
  day: 'Tag',
  days: 'Tage',
  delivery: 'Lieferverkehr',
  designated: 'öffentlich',
  destination: 'Anlieger',
  disabled: 'Menschen mit Behinderung',
  discouraged: 'nicht empfohlen',
  emergency: 'Einsatz-/Krankenfahrzeuge',
  doctors: 'Ärzt:innen',
  employees: 'Mitarbeiter',
  except: 'ausgenommen',
  forestry: 'Land-/Forstwirtschaftlicher Verkehr',
  hazmat: 'Gefahrguttransporte',
  height: 'Höhe',
  hgv: 'Lkw',
  hour: 'Stunde',
  hours: 'Stunden',
  illegible: 'unleserlich',
  large_events: 'Großveranstaltungen',
  length: 'Länge',
  'load-unload': 'Be- und Entladen',
  maxweightrating: 'zul. Gesamtgewicht (t)',
  military: 'Militärfahrzeuge',
  minute: 'Minute',
  minutes: 'Minuten',
  mobile_library: 'Bücherbus',
  motorcar: 'Pkw',
  motorcycle: 'Motorräder',
  motorhome: 'Wohnmobile',
  night: 'Nacht',
  nights: 'Nächte',
  no: 'kein Zugang',
  none: 'keine',
  off: 'ausgenommen',
  only: 'nur',
  other_comment: 'sonstiger Hinweis',
  other_condition: 'unklare Angabe',
  passenger_car: 'Pkw',
  permissive: 'geduldeter Zugang',
  permit: 'mit Genehmigung',
  private: 'privat',
  psv: 'Öffentliche Verkehrsmittel',
  residents: 'Bewohner:innen',
  snow: 'bei Schnee',
  spring: 'Frühling',
  stay: 'Parkdauer',
  summer: 'Sommer',
  sunrise: 'Sonnenaufgang',
  sunset: 'Sonnenuntergang',
  taxi: 'Taxen',
  week: 'Woche',
  weeks: 'Wochen',
  weight: 'Gewicht',
  wet: 'bei Nässe',
  wheels: 'Radanzahl',
  width: 'Breite',
  winter: 'Winter',
  yes: 'öffentlich',
} as const satisfies Record<string, string>
